module.exports = __webpack_public_path__ + "e6340369f97324c74cf9a3314ecc521b.svg";